export var get = function get(object, path) {
  var defValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  if (!path) {
    return defValue;
  }

  var pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  return pathArray.reduce(function (prevObj, key) {
    return prevObj && prevObj[key];
  }, object) || defValue;
};